import * as React from 'react';
import googlePlay from '../img/icons/google-play-badge.png'
import qrAndroid from '../img/icons/qr_app_android.png'

interface Props {
    wersjaPelna: boolean
}

export const AplikacjeMobilne = (props: Props) => {

    return (
        <>
            {(props.wersjaPelna)?
                // <div className={'container'}>
                    <div id={'main-container'} style={{marginTop: '0', marginBottom: '100px'}}>
                        <div className="row">
                            <div className="col-sm-4">
                                <h2 className={'h5'}>Pobierz aplikację mobilną</h2>
                                <p>Pobierz naszą aplikację mobilną i miej swoją <br/>e-kartę zawsze przy sobie!</p>
                                <i>
                                    Aplikacja jest dostępna w sklepie <a href='https://play.google.com/store/apps/details?id=topsa.merkurymarket.ekarta'>GooglePlay</a>
                                </i>
                                <p>
                                    <a href='https://play.google.com/store/apps/details?id=topsa.merkurymarket.ekarta'><img style={{width: 200}} alt={'Pobierz z Google Play'} src={googlePlay}/></a>
                                </p>
                            </div>
                            <div className="col-sm-4">
                                <img style={{width: 200}} alt={'Kod QR do pobrania aplikacji z Google Play'} src={qrAndroid}/>
                            </div>
                        </div>
                    </div>
                // </div>
            :
                <div id={'main-container'} style={{marginTop: '30px', marginBottom: '50px'}}>
                    <div className="row">
                        <div className="col-sm-5">
                            <h2 className={'h5'}>Pobierz aplikację mobilną</h2>
                            <p>Pobierz naszą aplikację mobilną i miej swoją <br/>e-kartę zawsze przy sobie!</p>
                            <i>
                                Aplikacja jest dostępna w sklepie <a href='https://play.google.com/store/apps/details?id=topsa.merkurymarket.ekarta'>GooglePlay</a>
                            </i>
                            <p>
                                <a href='https://play.google.com/store/apps/details?id=topsa.merkurymarket.ekarta'><img style={{width: 200}} alt={'Pobierz z Google Play'} src={googlePlay}/></a>
                            </p>
                        </div>
                        <div className="col-sm-3">
                            <img style={{width: 200}} alt={'Kod QR do pobrania aplikacji z Google Play'} src={qrAndroid}/>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

AplikacjeMobilne.defaultProps = {wersjaPelna: true}

